import classNames from 'classnames';
import styles from './EquipmentDetails.module.scss';
import { useEffect, useState } from 'react';
import {
	Button,
	Paragraph,
	Heading,
	InformationText,
	//  Picture,
	Link,
	Spinner,
} from 'ui/components';
// import { Swiper, SwiperSlide } from 'swiper/react';
import { Modal } from '../Modal';
//import { ProductDiscontinuedInfo } from '../ProductDiscontinuedInfo';
// import { currentCulture } from 'application/adapters/store/slices/cultureSlice';
// import { useSelector } from 'react-redux';

export interface EquipmentDetailsProps {
	className?: string;
	equipment: Models.CategoryProduct;
	imageSizes?: string;
	isLoggedIn?: boolean;
	//updateBasketCallback: (cartProduct: Models.UpdateBasketProduct) => void;
	//getProductPriceCallback: (cartProduct: Models.GetPriceRequest) => Promise<void>;
	basketId: string;
	profile?: {
		name?: string | null;
		email?: string | null;
		image?: string | null;
	};
	onSignIn: () => void;
	bpId: string;
	dictionary: { [key: string]: string };
}

export const EquipmentDetails: React.FC<EquipmentDetailsProps> = ({
	className,
	equipment,
	// imageSizes,
	isLoggedIn = false,
	//updateBasketCallback,
	//getProductPriceCallback,
	// basketId,
	profile,
	onSignIn,
	bpId,
	dictionary,
}) => {
	// const culture = useSelector(currentCulture);
	isLoggedIn = profile ? true : false;

	const [
		activeSlide,
		// setActiveSlide
	] = useState<number | string>(0);
	const [quantityValue, setQuantityValue] = useState<number | string>(1);

	const [isOpen, setIsOpen] = useState(false);
	const [
		isGettingPrice,
		// setIsGettingPrice
	] = useState(false);
	const handleClose = () => setIsOpen(false);

	const [openToastNoti, setOpenToastNoti] = useState<boolean>(false);
	const handleCloseModal = () => setOpenToastNoti(false);

	// function handleAddToCart() {
	// 	const cartProduct: Models.UpdateBasketProduct = {
	// 		basketId,
	// 		quantityDelta: Number(quantityValue),
	// 		sku: equipment?.sku,
	// 		cultureCode: culture,
	// 		bpId,
	// 	};
	// 	updateBasketCallback(cartProduct);
	// 	setOpenToastNoti(!openToastNoti);
	// }

	// const handleGetPrice = async () => {
	// 	setIsGettingPrice(true);
	// 	const reqData: Models.GetPriceRequest = {
	// 		qty: 1, //default value, if ever needs to be changed,
	// 		// consider adding a quantity input for price calculation
	// 		// that is either different from the one from add to cart or change the UI because it's confusing to use the same input for both
	// 		sku: equipment?.sku,
	// 		bpId,
	// 	};
	// 	await getProductPriceCallback(reqData);
	// 	setIsGettingPrice(false);
	// }

	// No scroll when Modal is open
	useEffect(() => {
		if (isOpen) {
			document.querySelector('body').style.overflow = 'hidden';
		} else {
			handleClose();
			document.querySelector('body').style.overflow = 'unset';
		}
	}, [isOpen]);

	// function swiperSlides() {
	// 	if (equipment?.productImages?.length > 0) {
	// 		return equipment?.productImages?.map((productImage, index) => {
	// 			return (
	// 				<SwiperSlide
	// 					className={styles.EquipmentDetails_swiperSlide}
	// 					key={index + 1}
	// 				>
	// 					<div
	// 						className={
	// 							styles.EquipmentDetails_swiperSlideContainer
	// 						}
	// 						onClick={() => setIsOpen(true)}
	// 					>
	// 						<Picture
	// 							url={productImage}
	// 							properties={{ altText: equipment?.name }}
	// 						/>
	// 					</div>
	// 				</SwiperSlide>
	// 			);
	// 		});
	// 	} else {
	// 		let defaultSlide;
	// 		if (equipment?.image) {
	// 			defaultSlide = (
	// 				<SwiperSlide
	// 					className={styles.EquipmentDetails_swiperSlide}
	// 					key={0}
	// 				>
	// 					<div
	// 						className={
	// 							styles.EquipmentDetails_swiperSlideContainer
	// 						}
	// 						onClick={() => setIsOpen(true)}
	// 					>
	// 						<Picture
	// 							sizes={imageSizes}
	// 							url={equipment.image}
	// 							properties={{ altText: equipment?.name }}
	// 						/>
	// 					</div>
	// 				</SwiperSlide>
	// 			);
	// 		}

	// 		let variantsSlide;
	// 		if (!equipment?.variants) {
	// 			variantsSlide = !equipment?.variants
	// 				? null
	// 				: equipment?.variants?.map((productVariant, index) => (
	// 						<SwiperSlide
	// 							className={styles.EquipmentDetails_swiperSlide}
	// 							key={index + 1}
	// 						>
	// 							<div
	// 								className={
	// 									styles.EquipmentDetails_swiperSlideContainer
	// 								}
	// 								onClick={() => setIsOpen(true)}
	// 							>
	// 								<Picture
	// 									sizes={imageSizes}
	// 									{...equipment?.image}
	// 								/>
	// 							</div>
	// 						</SwiperSlide>
	// 				  ));
	// 		}

	// 		return [defaultSlide, variantsSlide];
	// 	}
	// }

	return (
		<div className={classNames(styles.EquipmentDetails, className)}>
			{isOpen && <Modal handleClose={handleClose} modalType="productDetailsModal" product={equipment} activeSlide={activeSlide} />}
			{openToastNoti && (
				<Modal
					modalType="basketToastNotification"
					title={dictionary.confirmAddedToCart}
					ariaClose={'close'}
					handleClose={handleCloseModal}
					openToastNoti={openToastNoti}
				></Modal>
			)}
			{/* <div className={styles.EquipmentDetails_image}>
				<Swiper
					slidesPerView={1}
					// navigation
					pagination={{
						clickable: true,
						type: 'bullets',
					}}
					onSlideChange={(e) => {
						setActiveSlide(e.realIndex);
					}}
				>
					{swiperSlides()}
				</Swiper>
			</div> */}

			<div className={styles.EquipmentDetails_description}>
				{/* {equipment?.isDiscontinued && (
					<ProductDiscontinuedInfo
						replacements={equipment?.replacements}
						hasReplacements={equipment?.hasReplacements}
					/>
				)} */}
				{equipment?.sku && (
					<p className={styles.EquipmentDetails_serial}>
						{dictionary?.productNumber}
						<b className={styles.EquipmentDetails_serialvalue}>{equipment?.sku}</b>
					</p>
				)}

				{equipment?.name && (
					<Heading className={styles.EquipmentDetails_heading} headingLevel="h2">
						{equipment?.name}
					</Heading>
				)}

				{equipment?.shortDescription && <Paragraph className="u-top-margin--xs u-bottom-margin--xl">{equipment?.shortDescription}</Paragraph>}
				{equipment?.transportHazard && (
					<InformationText
						className={styles.EquipmentDetails_transportHazard}
						text={dictionary.transportHazard}
						iconText={dictionary.transportHazardInfo}
					/>
				)}
			</div>

			{/* ADD TO CART */}
			<div className={styles.EquipmentDetails_cart}>
				{isGettingPrice ? (
					<div className={styles.EquipmentDetails_spinner}>
						<Spinner size="large" speed="slow" center text={dictionary.waitText} />
					</div>
				) : equipment?.price?.formattedPrice != null || !isLoggedIn ? (
					<div className={styles.EquipmentDetails_priceWrapper}>
						<b className={classNames(styles.EquipmentDetails_priceLabel)}>{dictionary.price}</b>
						<div className={styles.EquipmentDetails_priceValueWrapper}>
							{isLoggedIn ? (
								<Heading headingLevel="h3" style="md">
									{equipment?.price?.currencyCode?.length === 3 && Number(equipment?.price?.price) > 0
										? equipment?.price?.formattedPrice
										: ``}
								</Heading>
							) : (
								<p className={styles.EquipmentDetails_price}>{dictionary?.signInToViewPrice}</p>
							)}
						</div>
					</div>
				) : (
					bpId && (
						<Button
							className={classNames(styles.EquipmentDetails_fetchPriceButton)}
							style="secondary"
							//onClick={() => handleGetPrice()}
						>
							{dictionary.fetchProductPrice}
						</Button>
					)
				)}

				{isLoggedIn ? (
					<>
						<div>
							<label htmlFor="quantity" className={styles.EquipmentDetails_quantityLabel}>
								{dictionary.quantityLabel}
							</label>
							<div className={styles.EquipmentDetails_action}>
								<input
									type="number"
									className={classNames(styles.EquipmentDetails_input, quantityValue === '' && styles.hasError)}
									name="quantity"
									value={quantityValue}
									min={1}
									onChange={(e) => {
										const value = e.target.value.replace(/[^\d]/, '');
										if (parseInt(value) !== 0) {
											setQuantityValue(value);
										}
									}}
								/>
								{/* <Button
									className={classNames(
										styles.EquipmentDetails_submitButton,
										styles.EquipmentDetails_submitButton___loggedIn,
									)}
									style="primary"
									disabled={
										quantityValue === '' ||
										!bpId ||
										equipment?.isDiscontinued
											? true
											: false
									}
									onClick={() => handleAddToCart()}
								>
									{dictionary?.addToCart}
								</Button> */}
							</div>
						</div>

						{!bpId && (
							<Link url={'/my-account/delivery-addresses'} className={styles.CheckoutReceipt_link}>
								{dictionary?.chooseBusinessPartner}
							</Link>
						)}
					</>
				) : (
					<>
						<Button
							className={styles.EquipmentDetails_submitButton}
							style="primary"
							onClick={() => {
								onSignIn();
							}}
						>
							{dictionary?.signInButton}
						</Button>
					</>
				)}
			</div>
		</div>
	);
};
